import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" onClick={handleClick} className="flex items-center gap-2 mb-4 cursor-pointer group">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-vip-diamond-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-lg font-bold text-secondary-50 whitespace-nowrap">
                  国产精品一区
                </span>
              </Link>
              <p className="text-sm text-secondary-400 leading-relaxed">
                精选优质国产原创内容聚合平台，为您提供流畅、高清、稳定的在线体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-secondary-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      onClick={handleClick}
                      className="text-sm text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-secondary-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" onClick={handleClick} className="text-sm text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" onClick={handleClick} className="text-sm text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">
                    使用条款
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-secondary-50 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-mail-line"></i>
                  <span>contact@guochanyiqu.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-phone-line"></i>
                  <span>400-000-0000</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-map-pin-line"></i>
                  <span>中国 · 北京</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-secondary-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              &copy; {new Date().getFullYear()} 国产精品一区 版权所有 | 精选优质国产原创内容聚合平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-secondary-500 hover:text-secondary-300 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-secondary-500 hover:text-secondary-300 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-secondary-500 hover:text-secondary-300 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}